export default __webpack_public_path__ + "static/media/man.c73a1795.png";